import Injectable from '@/modules/shared/domain/dependency_injection/injectable';
import { UpdatePersonRepository } from '../../../domain/repository/update-person-repository';

@Injectable()
export default class UpdatePersonDummyRepository implements UpdatePersonRepository {
  update(): Promise<any> {
    return Promise.resolve();
  }
}
